// Copy and list data for the signed-out landing page. Figures and customer names here are
// approved marketing claims — do not edit them without sign-off.

export const STATS = [
  { value: "80,000+", label: "mentoring sessions delivered" },
  { value: "3,000+", label: "industry mentors across Southeast Asia" },
  { value: "40+", label: "partner organisations" },
] as const;

export const PROBLEMS = [
  {
    number: "01",
    title: "Manual matching eats up the launch window",
    body: "Goals, experience, availability and programme criteria all have to line up, without endless back-and-forth.",
  },
  {
    number: "02",
    title: "Engagement drops quietly",
    body: "When sessions stall, programme owners often discover it too late to intervene.",
  },
  {
    number: "03",
    title: "Impact gets trapped in scattered feedback",
    body: "Stakeholders want evidence. HR is left piecing together attendance, feedback and progress by hand.",
  },
] as const;

export const STAGES = [
  {
    number: "01",
    label: "Design",
    title: "Set up your programme",
    body: "Bring programme goals, participant profiles and onboarding together.",
    outcome: "Setup done once",
  },
  {
    number: "02",
    label: "Match",
    title: "Match the right people",
    body: "Use smart matching or curate mentor–mentee pairs to fit your programme.",
    outcome: "No spreadsheet matching",
  },
  {
    number: "03",
    label: "Engage",
    title: "Keep sessions on track",
    body: "Schedule sessions, send reminders and track goals.",
    outcome: "Less chasing",
  },
  {
    number: "04",
    label: "Measure",
    title: "Report on progress",
    body: "Bring session activity, participant feedback and goal progress into clear reports.",
    outcome: "Clearer stakeholder updates",
  },
] as const;

export const FEATURED_STUDY = {
  name: "IJM",
  headline: ["40 leaders.", "120 sessions."],
  body: "A corporate mentoring programme involving senior managers, with an average mentor rating of 4.3 out of 5.",
} as const;

export const CASE_STUDIES = [
  {
    name: "MODEC HERizon",
    body: "A women’s leadership initiative supported by structured mentoring and development activities.",
  },
  {
    name: "Yayasan Peneraju",
    body: "A structured initiative that recorded improvements in decision-making confidence, communication and career progression.",
  },
  {
    name: "Synthomer",
    body: "Mentor training that prepared internal leaders to support employees through effective mentoring relationships.",
  },
] as const;

export const SERVICE_TIERS = [
  {
    eyebrow: "01 / Platform enablement",
    shortName: "Platform",
    summary: "Your team runs the programme.",
    title: "Your programme. Less admin.",
    body: "Best when your programme model and internal mentor pool are already in place.",
    badge: null,
    includes: [
      "Participant and cohort management",
      "Scheduling and session tracking",
      "Dashboards and reporting",
    ],
  },
  {
    eyebrow: "02 / Supported programme",
    shortName: "Supported",
    summary: "We help your team set up and launch.",
    title: "Your programme. Our launch support.",
    body: "Keep ownership while we help you set up, onboard, train, match and launch.",
    badge: "Most flexible",
    includes: ["Programme setup", "Mentor and mentee onboarding", "Matching, launch and reporting"],
  },
  {
    eyebrow: "03 / Managed programme",
    shortName: "Managed",
    summary: "We design and run the programme with you.",
    title: "From idea to measurable programme.",
    body: "We’re with you from programme design through launch and day-to-day running.",
    badge: null,
    includes: [
      "Programme and journey design",
      "Internal or external mentors",
      "Engagement and outcome measurement",
    ],
  },
] as const;
